module.exports = __webpack_public_path__ + "img/up.2236a611.svg";